export default function Currency(){
    return(
        <div className="cureency-section">
        <div className="container">
          <div className="row mb-none-30">
            <div className="col-lg-3 col-sm-6 cureency-item mb-30">
              <div className="cureency-card text-center">
                <h6 className="cureency-card__title text-white">BITCOIN PRICE</h6>
                <span className="cureency-card__amount h-font-family font-weight-600 base--color">
                  3150.00 USD
                </span>
              </div>
              {/* cureency-card end */}
            </div>
            {/* cureency-item end */}
            <div className="col-lg-3 col-sm-6 cureency-item mb-30">
              <div className="cureency-card text-center">
                <h6 className="cureency-card__title text-white">BITCOIN PRICE</h6>
                <span className="cureency-card__amount h-font-family font-weight-600 base--color">
                  2850.00 EUR
                </span>
              </div>
              {/* cureency-card end */}
            </div>
            {/* cureency-item end */}
            <div className="col-lg-3 col-sm-6 cureency-item mb-30">
              <div className="cureency-card text-center">
                <h6 className="cureency-card__title text-white">24 VOLUME</h6>
                <span className="cureency-card__amount h-font-family font-weight-600 base--color">
                  2,547.35 BTC
                </span>
              </div>
              {/* cureency-card end */}
            </div>
            {/* cureency-item end */}
            <div className="col-lg-3 col-sm-6 cureency-item mb-30">
              <div className="cureency-card text-center">
                <h6 className="cureency-card__title text-white">ACTIVE TRADES</h6>
                <span className="cureency-card__amount h-font-family font-weight-600 base--color">
                  2,545,875
                </span>
              </div>
              {/* cureency-card end */}
            </div>
            {/* cureency-item end */}
          </div>
        </div>
      </div>
      
    );
}